import PropTypes from 'prop-types'
import {List} from 'immutable'

import Carousel from '../../../../shared_components/Carousel'
import SuggestedDeputyBox from './SuggestedDeputyBox'
import useSuggestedDeputies from './useSuggestedDeputies'

import './suggestedDeputiesCarousel.scss'

const MAX_SUGGESTIONS = 10

// The carousel suggests contacts to deputize rather than an item to share, so it passes no
// arrangements to check permissions against and existing deputies are never suggested here.
const SuggestedDeputiesCarousel = ({
  context,
  deputies = List(),
  everplanId,
  location,
  onAddDeputy
}) => {
  const {onDismiss, onInvite, suggestedDeputies} = useSuggestedDeputies({
    context,
    deputies,
    everplanId,
    numberToDisplay: MAX_SUGGESTIONS,
    onAddDeputy
  })

  const slides = suggestedDeputies.map(contact => (
    <SuggestedDeputyBox
      contact={contact}
      key={contact.get('id')}
      deputies={deputies}
      onDismiss={onDismiss}
      onInvite={onInvite}
    />
  )).toArray()

  if (slides.length === 0)
    return null

  return (
    <div className='suggested-deputies-carousel'>
      <Carousel
        className='suggested-deputy-boxes'
        location={location}
        slides={slides}
        title='Add to your network'
      />
    </div>
  )
}

SuggestedDeputiesCarousel.propTypes = {
  context: PropTypes.string,
  deputies: PropTypes.instanceOf(List),
  everplanId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  onAddDeputy: PropTypes.func
}

export default SuggestedDeputiesCarousel
